var _g, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "85.333 85.333 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.046875 0 0 .049806 85.333 81.083)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 85.337,
    width: 512,
    height: 341.33
  }), /*#__PURE__*/React.createElement("rect", {
    y: 85.337,
    width: 512,
    height: 170.66
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 93.833,
    width: 24,
    height: 8.5,
    fill: "#d80027",
    strokeWidth: 0.048318
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoland);
export default __webpack_public_path__ + "static/media/poland.d775adca2dc8ec3726592abca22b632e.svg";
export { ForwardRef as ReactComponent };